<template>
  <app-layout>
    <div class="max-w-screen-xl mx-auto px-5">
      <el-breadcrumb class="my-5 w-full" separator="/">
        <el-breadcrumb-item
          :to="{ name: 'builder', params: { scaffoldId } }"
        >
          Relationships
        </el-breadcrumb-item>
        <el-breadcrumb-item class="b"
          >Relationship Form</el-breadcrumb-item
        >
      </el-breadcrumb>

      <el-form :model="relationship" ref="form">
        <el-form-item
          label="Type"
          prop="type"
          :rules="{
            required: true,
            message: 'Type is required',
            trigger: 'blur',
          }"
        >
          <el-select
            v-model="relationship.type"
            placeholder="Please select a type"
          >
            <el-option
              label="Many to Many"
              value="many-to-many-implicit"
            ></el-option>
            <el-option
              label="Many to One"
              value="many-to-one"
            ></el-option>
            <!-- <el-option
              label="Many to Many (Explicit)"
              value="many-to-many-explicit"
            ></el-option> -->
            <el-option
              label="One to One"
              value="one-to-one"
            ></el-option>
            <!-- <el-option
              label="Embedded"
              value="embedded"
            ></el-option> -->
          </el-select>

          <div
            class="leading-7 text-xs font-medium text-gray-500"
          >
            <div>
              - Many to Many: Relates many records to many
              others. Example: Category (Many) &lt;-> Post
              (Many).
            </div>
            <div>
              - Many to One: Relates many records to one.
              Example: Post (Many) &lt;-> Author (One).
            </div>
            <!-- <div>
              - Many to Many (Implicit): Relates many
              records to many others without extra fields on
              the join table. Example: Category (Many) &lt;->
              Post (Many).
            </div> -->
            <!-- <div>
              - Many to Many (Explicit): Relates two
              entities through one embedded entity. Example:
              Order (Editable Side) &lt;-> Order Item (Embedded)
              <-> Product (Related Side).
            </div> -->
            <div>
              - One to One: Relates one record to only one
              other. Example: Profile (One - has Foreign
              Key) &lt;-> User (one).
            </div>
            <!-- <div>
              - Embedded: Relates one record to an embedded
              entity. Example: Order (Editable Side) &lt;->
              Order Item (Embedded).
            </div> -->
          </div>
        </el-form-item>

        <el-form-item
          v-if="
            relationship.type === 'embedded' ||
              relationship.type === 'many-to-many-explicit'
          "
          label="Embedded Entity"
          prop="embeddedEntity"
          :rules="{
            required: true,
            message: 'Embedded Entity is required',
            trigger: 'blur',
          }"
        >
          <el-select
            v-model="relationship.embeddedEntity"
            placeholder="Please select an entity"
          >
            <el-option
              key="membership"
              label="Membership (User)"
              value="membership"
            ></el-option>
            <el-option
              v-for="entity in embeddedEntities"
              :key="entity.id"
              :label="entity.label.singular"
              :value="entity.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <div
          class="grid md:grid-cols-1 lg:grid-cols-2 lg:gap-8"
        >
          <div
            class="mt-4 block border-2 rounded border-gray-100"
          >
            <h2
              class="p-2 pl-4 border-b-2 border-gray-100 w-full bg-gray-50 block uppercase tracking-wide text-gray-700 text-xs font-semibold"
            >
              <span
                v-if="relationship.type === 'many-to-one'"
              >
                Side A (Relates to One)
              </span>
              <span
                v-if="
                  relationship.type ===
                    'many-to-many-implicit'
                "
              >
                Side A (Relates to Many)
              </span>
              <span
                v-if="
                  relationship.type ===
                    'many-to-many-explicit'
                "
              >
                Editable Side
              </span>
              <span v-if="relationship.type === 'embedded'">
                Editable Side
              </span>
              <span
                v-if="relationship.type === 'one-to-one'"
              >
                Side A (Relates to One - Has Foreign Key)
              </span>
            </h2>

            <div class="p-4">
              <el-form-item
                label="Entity"
                prop="entityA"
                :rules="{
                  required: true,
                  message: 'Entity is required',
                  trigger: 'blur',
                }"
              >
                <el-select
                  v-model="relationship.entityA"
                  placeholder="Please select an entity"
                >
                  <el-option
                    v-for="entity in fullEntities"
                    :key="entity.id"
                    :label="entity.label.singular"
                    :value="entity.id"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                label="Field Name"
                prop="fieldNameA"
                :rules="[
                  {
                    required: true,
                    message: 'Field Name is required',
                    trigger: 'blur',
                  },
                  {
                    pattern: /^[_a-zA-Z][_a-zA-Z0-9]*$/,
                    message:
                      'Field Name is not a valid variable name',
                    trigger: 'blur',
                  },
                  {
                    pattern: variableNamePattern,
                    message:
                      'Field Name is not a valid variable name',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  v-model="relationship.fieldNameA"
                  v-on:input="onFieldNameAChange()"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="Field Label"
                prop="fieldLabelA"
                :rules="{
                  required: true,
                  message: 'Field Label is required',
                  trigger: 'blur',
                }"
              >
                <el-input
                  v-model="relationship.fieldLabelA"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="Editable"
                ref="editableA"
                v-if="
                  relationship.type === 'many-to-one' ||
                    relationship.type === 'one-to-one' ||
                    relationship.type ===
                      'many-to-many-implicit'
                "
              >
                <el-select v-model="relationship.editableA">
                  <el-option
                    label="Yes"
                    value="yes"
                  ></el-option>
                  <el-option
                    label="No"
                    value="no"
                  ></el-option>
                </el-select>

                <div
                  class="leading-7 text-xs font-medium text-gray-500"
                >
                  Field appears and is editable on the form.
                </div>
              </el-form-item>

              <el-form-item
                label="Required"
                ref="requiredA"
                v-if="
                  (relationship.type === 'many-to-one' ||
                    relationship.type === 'one-to-one') &&
                    relationship.entityA !==
                      relationship.entityB
                "
              >
                <el-select v-model="relationship.requiredA">
                  <el-option
                    label="Yes"
                    value="yes"
                  ></el-option>
                  <el-option
                    label="No"
                    value="no"
                  ></el-option>
                </el-select>
                <div
                  class="leading-7 text-xs font-medium text-gray-500"
                >
                  Field is required on the form.
                </div>
              </el-form-item>

              <el-form-item
                v-if="relationship.requiredA !== 'yes'"
                label="Relation Action A"
              >
                <el-select
                  v-model="relationship.relationActionA"
                  placeholder="Select an action"
                >
                  <el-option
                    label="Nullify"
                    value="nullify"
                  ></el-option>
                  <el-option
                    label="Restrict"
                    value="restrict"
                  ></el-option>
                </el-select>
                <div
                  class="leading-7 text-xs font-medium text-gray-500"
                >
                  <!-- <div>
                  - Cascade: Deleting a referenced record
                  will trigger the deletion of referencing
                  record.
                </div> -->
                  <div>
                    - Nullify: On deletion, referencing
                    records will have the relation set to
                    null.
                  </div>
                  <div>
                    - Restrict: Prevents the deletion if any
                    referencing records exist.
                  </div>
                </div>
              </el-form-item>

              <el-form-item
                label="List?"
                v-if="
                  relationship.type === 'many-to-one' ||
                    relationship.type === 'one-to-one' ||
                    relationship.type ===
                      'many-to-many-implicit'
                "
              >
                <el-select v-model="relationship.listA">
                  <el-option
                    label="Yes"
                    value="yes"
                  ></el-option>
                  <el-option
                    label="No"
                    value="no"
                  ></el-option>
                </el-select>

                <div
                  class="leading-7 text-xs font-medium text-gray-500"
                >
                  Displays the field on the listing page.
                </div>
              </el-form-item>

              <el-form-item
                label="Filter?"
                v-if="
                  relationship.type === 'many-to-one' ||
                    relationship.type === 'one-to-one' ||
                    relationship.type ===
                      'many-to-many-implicit'
                "
              >
                <el-select v-model="relationship.filterA">
                  <el-option
                    label="Yes"
                    value="yes"
                  ></el-option>
                  <el-option
                    label="No"
                    value="no"
                  ></el-option>
                </el-select>

                <div
                  class="leading-7 text-xs font-medium text-gray-500"
                >
                  Creates a filter for this field on the
                  listing page.
                </div>
              </el-form-item>

              <el-form-item
                label="Export to CSV?"
                v-if="
                  relationship.type === 'many-to-one' ||
                    relationship.type === 'one-to-one' ||
                    relationship.type ===
                      'many-to-many-implicit'
                "
              >
                <el-select v-model="relationship.exportA">
                  <el-option
                    label="Yes"
                    value="yes"
                  ></el-option>
                  <el-option
                    label="No"
                    value="no"
                  ></el-option>
                </el-select>

                <div
                  class="leading-7 text-xs font-medium text-gray-500"
                >
                  Include the field in the exported CSV
                  file.
                </div>
              </el-form-item>
            </div>
          </div>

          <div
            v-if="relationship.type !== 'embedded'"
            class="mt-4 block border-2 rounded border-gray-100"
          >
            <h2
              class="p-2 pl-4 border-b-2 border-gray-100 w-full bg-gray-50 block uppercase tracking-wide text-gray-700 text-xs font-semibold"
            >
              <span
                v-if="relationship.type === 'many-to-one'"
              >
                Side B (Relates to Many)
              </span>
              <span
                v-if="
                  relationship.type ===
                    'many-to-many-implicit'
                "
              >
                Side B (Relates to Many)
              </span>
              <span
                v-if="
                  relationship.type ===
                    'many-to-many-explicit'
                "
              >
                Related Side
              </span>

              <span
                v-if="relationship.type === 'one-to-one'"
              >
                Side B (Relates to One)
              </span>
            </h2>

            <div class="p-4">
              <el-form-item
                label="Entity"
                prop="entityB"
                :rules="{
                  required: true,
                  message: 'Entity is required',
                  trigger: 'blur',
                }"
              >
                <el-select
                  v-model="relationship.entityB"
                  placeholder="Please select an entity"
                >
                  <el-option
                    v-for="entity in fullEntitiesWithMembership"
                    :key="entity.id"
                    :label="entity.label.singular"
                    :value="entity.id"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                label="Field Name"
                prop="fieldNameB"
                :rules="[
                  {
                    required: true,
                    message: 'Field Name is required',
                    trigger: 'blur',
                  },
                  {
                    pattern: /^[_a-zA-Z][_a-zA-Z0-9]*$/,
                    message:
                      'Field Name is not a valid variable name',
                    trigger: 'blur',
                  },
                  {
                    pattern: variableNamePattern,
                    message:
                      'Field Name is not a valid variable name',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  v-model="relationship.fieldNameB"
                  v-on:input="onFieldNameBChange()"
                ></el-input>
              </el-form-item>

              <el-form-item
                v-if="relationship.entityB !== 'membership'"
                label="Field Label"
                prop="fieldLabelB"
                :rules="{
                  required: true,
                  message: 'Field Label is required',
                  trigger: 'blur',
                }"
              >
                <el-input
                  v-model="relationship.fieldLabelB"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="Editable"
                ref="editableB"
                v-if="
                  relationship.entityB !== 'membership' &&
                    (relationship.type === 'many-to-one' ||
                      (relationship.type === 'one-to-one' &&
                        relationship.requiredA === 'no') ||
                      relationship.type ===
                        'many-to-many-implicit')
                "
              >
                <el-select v-model="relationship.editableB">
                  <el-option
                    label="Yes"
                    value="yes"
                  ></el-option>
                  <el-option
                    label="No"
                    value="no"
                  ></el-option>
                </el-select>

                <div
                  class="leading-7 text-xs font-medium text-gray-500"
                >
                  Field appears and is editable on the form.
                </div>
              </el-form-item>

              <el-form-item
                label="Relation Action B"
                v-if="relationship.entityB !== 'membership'"
              >
                <el-select
                  v-model="relationship.relationActionB"
                  placeholder="Select an action"
                >
                  <el-option
                    label="Nullify"
                    value="nullify"
                  ></el-option>
                  <el-option
                    label="Restrict"
                    value="restrict"
                  ></el-option>
                </el-select>
                <div
                  class="leading-7 text-xs font-medium text-gray-500"
                >
                  <!-- <div>
                  - Cascade: Deleting a referenced record
                  will trigger the deletion of referencing
                  record.
                </div> -->
                  <div>
                    - Nullify: On deletion, referencing
                    records will have the relation set to
                    null.
                  </div>
                  <div>
                    - Restrict: Prevents the deletion if any
                    referencing records exist.
                  </div>
                </div>
              </el-form-item>

              <el-form-item
                label="List?"
                v-if="
                  relationship.entityB !== 'membership' &&
                    (relationship.type === 'many-to-one' ||
                      relationship.type === 'one-to-one' ||
                      relationship.type ===
                        'many-to-many-implicit')
                "
              >
                <el-select v-model="relationship.listB">
                  <el-option
                    label="Yes"
                    value="yes"
                  ></el-option>
                  <el-option
                    label="No"
                    value="no"
                  ></el-option>
                </el-select>

                <div
                  class="leading-7 text-xs font-medium text-gray-500"
                >
                  Displays the field on the listing page.
                </div>
              </el-form-item>

              <el-form-item
                label="Filter?"
                v-if="
                  relationship.entityB !== 'membership' &&
                    (relationship.type === 'one-to-one' ||
                      relationship.type === 'many-to-one' ||
                      relationship.type ===
                        'many-to-many-implicit')
                "
              >
                <el-select v-model="relationship.filterB">
                  <el-option
                    label="Yes"
                    value="yes"
                  ></el-option>
                  <el-option
                    label="No"
                    value="no"
                  ></el-option>
                </el-select>

                <div
                  class="leading-7 text-xs font-medium text-gray-500"
                >
                  Creates a filter for this field on the
                  listing page.
                </div>
              </el-form-item>

              <el-form-item
                label="Export to CSV?"
                v-if="
                  relationship.entityB !== 'membership' &&
                    (relationship.type === 'many-to-one' ||
                      relationship.type === 'one-to-one' ||
                      relationship.type ===
                        'many-to-many-implicit')
                "
              >
                <el-select v-model="relationship.exportB">
                  <el-option
                    label="Yes"
                    value="yes"
                  ></el-option>
                  <el-option
                    label="No"
                    value="no"
                  ></el-option>
                </el-select>

                <div
                  class="leading-7 text-xs font-medium text-gray-500"
                >
                  Include the field in the exported CSV
                  file.
                </div>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>

      <app-builder-debugger
        v-if="debugging"
        :data="relationship"
      ></app-builder-debugger>

      <div class="my-4">
        <el-button type="primary" @click="save()"
          >Save</el-button
        >
        <router-link
          class="el-button"
          :to="{ name: 'builder', params: { scaffoldId } }"
          >Cancel</router-link
        >
      </div>
    </div>
  </app-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import variableNamePattern from '../../util/variable-name-regex';
import NameLabelNormalizer from '../name-label-normalizer';

export default {
  name: 'app-relationship-form',

  props: ['scaffoldId', 'id', 'reload'],

  created() {
    if (!this.$store.getters['scaffold/current']) {
      this.$router.push({
        name: 'builder',
        params: { scaffoldId: this.scaffoldId },
      });
      return;
    }

    const create = !this.id;

    if (create) {
      this.$store.dispatch(
        'builder/relationshipCurrent/new',
      );
    } else {
      const relationship = this.$store.getters[
        'builder/relationshipCurrent/get'
      ](this.id, !!this.reload);

      if (relationship) {
        this.$store.dispatch(
          'builder/relationshipCurrent/edit',
          relationship,
        );
      } else {
        this.$router.push({
          name: 'builder',
          params: { scaffoldId: this.scaffoldId },
        });
      }
    }
  },

  computed: {
    ...mapGetters({
      scaffold: 'scaffold/current',
      debugging: 'builder/debugging',
      relationship: 'builder/relationshipCurrent/current',
      entities: 'builder/entityCurrent/list',
    }),

    variableNamePattern() {
      return variableNamePattern;
    },

    embeddedEntities() {
      // return this.entities.filter(
      //   (entity) => entity.type === 'embedded',
      // );
      return [];
    },

    fullEntities() {
      // return this.entities.filter(
      //   (entity) => entity.type === 'full',
      // );
      return this.entities;
    },

    fullEntitiesWithMembership() {
      return [
        {
          id: 'membership',
          name: {
            singular: 'membership',
          },
          label: {
            singular: 'Membership (User)',
            plural: 'Memberships (Users)',
          },
          type: 'full',
        },
        ...this.fullEntities,
      ];
    },
  },

  methods: {
    save() {
      const { dispatch } = this.$store;

      if (
        [
          'one-to-one',
          'many-to-one',
          'many-to-many-implicit',
        ].includes(this.relationship.type)
      ) {
        if (
          this.relationship.editableA === 'no' &&
          this.relationship.editableB === 'no'
        ) {
          this.$refs.editableA.error =
            'At least one side must be editable';
          return;
        }
      }

      this.$refs.form.validate((valid) => {
        if (valid) {
          dispatch('builder/relationshipCurrent/save')
            .then(() => {
              this.$router.push({
                name: 'builder',
                params: { scaffoldId: this.scaffoldId },
              });
            })
            .catch(() => {
              // ignore, it is a validation error
            });
        }
      });
    },

    onFieldNameAChange() {
      const fieldNameASingular = this.relationship
        .fieldNameA;

      this.relationship.fieldLabelA = NameLabelNormalizer.createLabel(
        fieldNameASingular,
      );
    },

    onFieldNameBChange() {
      const fieldNameBSingular = this.relationship
        .fieldNameB;

      this.relationship.fieldLabelB = NameLabelNormalizer.createLabel(
        fieldNameBSingular,
      );
    },
  },
};
</script>

<style></style>
